import { formatCurrency } from "../../../../../helpers";
import styles from "./styles.module.scss";

export const PriceSummary = ({ orderDetails }) => {
  const store_currency = orderDetails?.store?.currency_code;

  return (
    <div className={styles.priceSummary}>
      <p className="dark--text text-center">Price Summary</p>
      <div>
        <p>Subtotal</p>
        <p className="dark--text font-weight-semibold">
          {formatCurrency({
            value: orderDetails?.total_item_amount,
            currencyCode: store_currency,
          })}
        </p>
      </div>
      {orderDetails?.giftcard_debit_amount ? (
        <div>
          <p>Gift Card</p>
          <p className="dark--text font-weight-semibold">
            {formatCurrency({
              value: orderDetails?.giftcard_debit_amount || 0,
              currencyCode: store_currency,
            })}
          </p>
        </div>
      ) : null}
      {orderDetails?.loyalty_debit_amount ? (
        <div>
          <p>Loyalty Amount</p>
          <p className="dark--text font-weight-semibold">
            {formatCurrency({
              value: orderDetails?.loyalty_debit_amount || 0,
              currencyCode: store_currency,
            })}
          </p>
        </div>
      ) : null}
      <div>
        <p>Discount</p>
        <p className="dark--text font-weight-semibold">
          {formatCurrency({
            value: orderDetails?.discount_amount || 0,
            currencyCode: store_currency,
          })}
        </p>
      </div>
      <div>
        <p>Delivery Fee</p>
        <p className="dark--text font-weight-semibold">
          {formatCurrency({
            value: orderDetails?.delivery_fee_amount || 0,
            currencyCode: store_currency,
          })}
        </p>
      </div>
      <div>
        <p>
          VAT (
          {isNaN(Number(orderDetails?.vat_percentage))
            ? 0
            : Number(orderDetails?.vat_percentage)}
          %)
        </p>
        <p className="dark--text font-weight-semibold">
          {formatCurrency({
            value: orderDetails?.vat || 0,
            currencyCode: store_currency,
          })}
        </p>
      </div>
      <div>
        <p>
          Service Charge (
          {isNaN(Number(orderDetails?.service_charge_percentage))
            ? 0
            : Number(orderDetails?.service_charge_percentage)}
          %)
        </p>
        <p className="dark--text font-weight-semibold">
          {formatCurrency({
            value: orderDetails?.service_charge || 0,
            currencyCode: store_currency,
          })}
        </p>
      </div>
      <div>
        <p className="dark--text font-weight-semibold">Total</p>
        <h5 className="success--text">
          {formatCurrency({
            value: orderDetails?.total_amount,
            currencyCode: store_currency,
          })}
        </h5>
      </div>
    </div>
  );
};
